import { UserRoles } from "../../security/userroles.type";

export class UserSessionType {
    userName: string;
    fullName: string;
    avatarUrl: string;
    token: string;
    tokenType: string;
    refreshToken: string;
    childrenCompanies: number[];
    isOwner: boolean;
    timeZoneInfo: string;
    rolesNames: Array<string>;
    tenantId: number;
    id: number;
    accountId: number;
    employeeId: number;
    companyIsSaaSOwner: boolean;
    companyId: number;
    companyEmail: string;
    companyName: string;
    companyLogo: string;
    menu: any[];
    modules: any[];
    isNewUser: boolean;
    userEmail: string;
    firstName: string;
    lastName: string;
    has2FA: boolean;
}
